import { useCallback, useState } from 'react';

import type { ToolApprovalResponse } from '@aline/common';
import * as Sentry from '@sentry/react';
import { useSnackbar } from 'notistack';
import { useChatAdapter } from 'src/components/ai/chat/ChatPanelMarkdown/ChatPanelMarkdown';

/** Sends an approval card's response, reporting a failure in a snackbar. */
export function useSubmitApprovalResponse() {
  const { enqueueSnackbar } = useSnackbar();
  const { addToolApprovalResponse } = useChatAdapter();
  const [submitting, setSubmitting] = useState(false);

  const submit = useCallback(
    async (response: ToolApprovalResponse) => {
      try {
        setSubmitting(true);
        await addToolApprovalResponse(response);
      } catch (error) {
        Sentry.captureException(error);
        enqueueSnackbar('Failed to submit your response. Please try again.', { variant: 'error' });
      } finally {
        setSubmitting(false);
      }
    },
    [addToolApprovalResponse, enqueueSnackbar]
  );

  return { submit, submitting };
}
